
import React from 'react';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import PlatformSettings from '@/components/admin/PlatformSettings';
import { useIsMobile } from '@/hooks/use-mobile';

const AdminPlatformSettings = () => {
  const { user } = useInternalAuth();
  const isMobile = useIsMobile();

  if (!user || user.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full px-4 md:px-6 ${
        isMobile 
          ? 'mt-16 mb-16 py-4' 
          : 'mt-24 mb-6 py-6 md:py-12'
      }`}>
        <div className="w-full max-w-7xl mx-auto">
          <PlatformSettings onBack={() => window.history.back()} />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default AdminPlatformSettings;
